import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__copyright">© 2024 Fusion - Tous droits réservés.</p>
      <a href="/mentions-legales" className="footer__legal-notice">Mentions légales</a>
    </footer>
  );
};

export default Footer;
